module.exports = __webpack_public_path__ + "static/media/training_library_upload.d4b5ddf6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/training_library_upload.svg
// module id = 2723
// module chunks = 0